import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import AutocompleteInput from './AutocompleteInput';
import _ from 'underscore';

import config from "./../config";

class SearchBox extends Component {
	constructor(props) {
		super(props);

		this.inputKeyPressHandler = this.inputKeyPressHandler.bind(this);
		this.inputChangeHandler = this.inputChangeHandler.bind(this);
		this.executeSearch = this.executeSearch.bind(this);
		this.formatAutocompleteListItems = this.formatAutocompleteListItems.bind(this);
		this.formatAutocompleteList = this.formatAutocompleteList.bind(this);
		this.formatAutocompleteListLink = this.formatAutocompleteListLink.bind(this);
		this.searchBoxItemSelectHandler = this.searchBoxItemSelectHandler.bind(this);
		this.inputFocusHandler = this.inputFocusHandler.bind(this);
		this.formatAutocompleteListItemsES = this.formatAutocompleteListItemsES.bind(this);

		this.state = {
			searchBoxInput: '',
			searchOrdabok: ''
		};
	}

	inputKeyPressHandler(event) {
		if (event.key == 'Enter') {
			this.executeSearch();
		}
	}

	inputChangeHandler(event) {
		var stateObj = {};

		stateObj[event.target.name] = event.target.value;

		this.setState(stateObj);
	}

	componentDidMount() {
		if (this.props.searchString) {
			this.setState({
				searchBoxInput: this.props.searchString
			});
		}

		this.refs.searchInput.refs.inputField.focus();

		setTimeout(function() {
			this.inputFocusHandler();
		}.bind(this), 100);
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.searchString != prevProps.searchString) {
			this.setState({
				searchBoxInput: this.props.searchString
			});
		}
		if (this.props.searchOrdabok != prevProps.searchOrdabok) {
			this.setState({
				searchOrdabok: this.props.searchOrdabok
			});
		}
	}

	searchBoxItemSelectHandler(item) {
//		this.props.history.push('/faersla/'+item.uid);
//		this.executeSearch();
	}

	inputFocusHandler() {
		this.refs.searchInput.refs.inputField.select();
	}

	executeSearch() {
		this.props.history.push('/leit/'+this.decodeURIComponentSafe(this.state.searchBoxInput)+(this.state.searchOrdabok ? '/ordabok/'+this.state.searchOrdabok : ''));
	}

	formatAutocompleteListItems(item) {
		// Birting á orðabókarfærslum í sprettiniðurstöðum
		var wordEls = [];

		return  <div className="pt-2 pb-2">
			
				<Link to={'/leit/'+this.decodeURIComponentSafe(item.word)}><strong>{item.word}</strong></Link>
				<div className="mt-2">
					{
						item.data.map(function(wordDataItem, index) {
							return <React.Fragment key={index}>
								<Link to={'/faersla/'+wordDataItem.fkterm}><strong>{wordDataItem.fklanguage}</strong> <em>{window.ordabankiData.dictionaries && window.ordabankiData.dictionaries[wordDataItem.fkdictionary] ? window.ordabankiData.dictionaries[wordDataItem.fkdictionary] : wordDataItem.fkdictionary}</em></Link>
								{
									index < item.data.length-1 &&
									<span>, </span>
								}
							</React.Fragment>
						})
					}
				</div>
			
		</div>;

		if (item.words.length > 0) {
			try {
				wordEls = item.words.map(function(word, index) {
					// Sérstök merking á orði sem passar við það sem verið er að leita að
					let wordEl = word.word.toLowerCase().indexOf(this.state.searchBoxInput.toLowerCase()) > -1 ? <React.Fragment key={index}><mark><strong>{word.fklanguage.toLowerCase()}</strong>: <u>{word.word}</u></mark> </React.Fragment> : <React.Fragment key={index}><strong>{word.fklanguage.toLowerCase()}</strong>: {word.word} </React.Fragment>;
					return wordEl;
				}.bind(this));
			}
			catch (e) {}
		}

		return <div className="pt-2 pb-2 flex-column">
			{
				wordEls.length > 0 &&
				<span className="mt-3 d-flex w-100 justify-content-between"><span>{wordEls}</span> <span className="text-right"><em>{window.ordabankiData.dictionaries && window.ordabankiData.dictionaries[item.fkdictionary] ? window.ordabankiData.dictionaries[item.fkdictionary] : item.fkdictionary}</em></span></span>
			}
		</div>;
	}

	formatAutocompleteListItemsES(item) {
		// Birting á orðabókarfærslum í sprettiniðurstöðum
		var wordEls = [];

		return  <div className="pt-2 pb-2">
			
				<Link to={'/leit/'+this.decodeURIComponentSafe(item.word)}><strong>{item.word}</strong></Link>
				<div className="mt-2">
					{
						item.dictionaries.map(function(wordDataItem, index) {
							return <React.Fragment key={index}>
								<Link to={'/faersla/'+wordDataItem.term_id}><strong>{item.language}</strong> <em>{window.ordabankiData.dictionaries && window.ordabankiData.dictionaries[wordDataItem.dictionary] ? window.ordabankiData.dictionaries[wordDataItem.dictionary] : wordDataItem.dictionary}</em></Link>
								{
									index < item.dictionaries.length-1 &&
									<span>, </span>
								}
							</React.Fragment>
						})
					}
				</div>
			
		</div>;
	}

	decodeURIComponentSafe(uri, mod) {
		uri = uri.split('%').join('');

		var out = new String(),
			arr,
			i = 0,
			l,
			x;
		typeof mod === "undefined" ? mod = 0 : 0;
		arr = uri.split(/(%(?:d0|d1)%.{2})/);
		for (l = arr.length; i < l; i++) {
			try {
				x = decodeURIComponent(arr[i]);
			} catch (e) {
				x = mod ? arr[i].replace(/%(?!\d+)/g, '%25') : arr[i];
			}
			out += x;
		}
		return out;
	}

	formatAutocompleteList(data) {
		let grouped = _.groupBy(data, 'word');

		let ret = Object.keys(grouped).map(function(key) {
			return {
				word: key,
				data: grouped[key]
			};
		});

		ret.length = 10;

		return ret;
	}

	formatAutocompleteListLink(item) {
		return '/leit/'+this.decodeURIComponentSafe(item.word);
	}

	render() {
		return (
			<div className="form-group row">
				<div className="col-9 col-sm-10 col-md-11"> 
					<AutocompleteInput inputClassName="form-control" 
						ref="searchInput"
						responseDataField="results"
						//searchUrl={config.apiRoot+'/api/index/?limit=30&search=$s'}
						searchUrl={config.apiRoot+'/api/es/autocomplete?ord=$s'}
						onChange={this.inputChangeHandler} 
						inputName="searchBoxInput" 
						value={this.state.searchBoxInput} 
						type="text" 
						onEnter={this.executeSearch} 
						onItemSelect={this.searchBoxItemSelectHandler}
						placeholder="Leita í íðorðabanka"
						minChars={2}
						valueField="word"
						selectedItemClass="active"
						onFocus={this.inputFocusHandler}
						disableAutoFill={false} 
						headerText="Ýttu á enter til að leita eða veldu orðasafn úr lista til að sjá færslu."
						listLabelFormatFunc={this.formatAutocompleteListItemsES} 
						//dataFormatFunc={this.formatAutocompleteList}
						listLinkFormatFunc={this.formatAutocompleteListLink}
					/>
					{
						this.state.searchOrdabok &&
						<div className="badge badge-secondary" style={{
							position: 'absolute',
							top: 11,
							right: 25
						}}>{window.ordabankiData.dictionaries && window.ordabankiData.dictionaries[this.state.searchOrdabok] ? window.ordabankiData.dictionaries[this.state.searchOrdabok] : this.state.searchOrdabok} | <span className="cursor-pointer" onClick={function() {
							this.setState({
								searchOrdabok: ''
							})
						}.bind(this)}>X</span></div>
					}
				{
					/*
					<input name="searchBoxInput"
						className="form-control"
						placeholder="Leit í orðabanka"
						type="text"
						value={this.state.searchBoxInput}
						onKeyPress={this.inputKeyPressHandler} 
						onChange={this.inputChangeHandler}
					/>
					*/
				}
				</div>
				<div className="col-2 col-md-1">
					<button onClick={this.executeSearch.bind(this)} className="btn btn-primary">Leita</button>
				</div>
			</div>
		);
	}
}

export default withRouter(SearchBox);



// WEBPACK FOOTER //
// ./src/components/SearchBox.js